export const PROFILE_FIELD_MAX_LENGTH = 50;

const LIMITED_FIELDS = new Set([
  "first_name",
  "last_name",
  "institution",
  "occupation",
  "department",
  "advisor",
]);

export const getProfileFieldError = (field, value) =>
  LIMITED_FIELDS.has(field) &&
  Array.from(value || "").length > PROFILE_FIELD_MAX_LENGTH
    ? `Maximum ${PROFILE_FIELD_MAX_LENGTH} characters.`
    : "";
